'use strict';

/**
 * Defines the properties and methods that every child transform class should
 * implement
 */

var _ = require('lodash');
var LayerStyles = require('./lib/LayerStyles');
var MarkerUtil = require('./lib/MarkerUtil');
var RouteUtil = require('./lib/RouteUtil');
var Transform = require('../../../Transform');

var RouteTransform = Transform.extend({

  collection: 'routes', // name of the collection to set in mission store

  /**
   * The key on the layer under which the GeoJSON data is stored
   * @type {String}
   */
  geojsonKey: 'data',
  
  /**
   * Default layer styles for different states. Should return an object with  
   * three states: active, default, dim
   * 
   * @return {Object} 
   */
  getLayerStateStyles: function (rlayer) {
    if (rlayer.type === 'route') {
      return LayerStyles.polyline;
    } else if (rlayer.type === 'waypoint') {
      return LayerStyles.waypoint;
    } else if (rlayer.type === 'routeLabel') {
      return LayerStyles.label;
    }
  },

  getCollection: function (data) {
    
    var collection = [];
    var routes = data.routes;
    var paths = [];
    var waypoints = [];
    var labels = [];

    // 1. add the waypoints path for each route as a single polyline
    // 2. if the route is an `odd` index add two with same vertices: one solid, one dashed
    _.forEach(routes, function (route, index) {
      setWaypointTags(route, index, routes.length - 1);
      waypoints = waypoints.concat(routes[index].waypoints);

      var latlngs = getWaypointCoords(route);
      var routePaths = RouteUtil.getRoutePaths(latlngs, index);
      var routeLabel = RouteUtil.getRouteLabel(routePaths[0], route.label);

      paths = paths.concat(routePaths);
      labels = labels.concat(routeLabel);
    });
    
    collection = paths.concat(labels, waypoints);

    function getWaypointCoords (route) {
      return _.map(route.waypoints, function (waypoint) {
        return waypoint.data.geometry.coordinates;
      });
    }

    /**
     * Make sure the very first and waypoint and the start and end
     * of each route have special tags so that they can have different styling
     * applied to them when rendered
     */
    function setWaypointTags (route, routeIndex, lastRouteIndex) {
      if (!route.waypoints[0].$tags) {
        if (routeIndex === 0) {
          route.waypoints[0].$tags = 'start, routeStart';
        } else {
          route.waypoints[0].$tags = 'routeStart';
        }
      }

      var last = route.waypoints.length - 1;
      if (!route.waypoints[last].$tags) {
        if (routeIndex === lastRouteIndex) {
          route.waypoints[last].$tags = 'end, routeEnd';
        } else {
          route.waypoints[last].$tags = 'routeEnd';
        }
      }
    }

    return collection;
  },

  /**
   * Transform a layer type into a type that leaflet understands.
   * Should return one of [circle, marker, polygon, polyline, rectangle]. 
   *
   * @param  {Object} rlayer  Raw layer data
   * @return {String} type {circle|marker|polygon|polyline|rectangle}
   */
  getLeafletTypeFromLayer: function (rlayer) {
    if (rlayer.type === 'waypoint' || rlayer.type === 'routeLabel') {
      return 'marker';
    } else if (rlayer.type === 'route') {
      return 'polyline';
    }
  },

  isLayerClickable: function (rlayer) {
    /* jshint unused:false */
    if (rlayer.type === 'route' || rlayer.type === 'routeLabel') {
      return false;
    } else {
      return true;
    }
  },

  isLayerEditable: function (rlayer) {
    /* jshint unused:false */
    return false;
  },

  /**
   * This is a callback function executed when Leaflet is generating the layer
   * from the GeoJSON data and is used to convert a `point` into the appropriate
   * LeafletLayer type.
   *
   * @param  {Object} rlayer  Raw layer data
   * @param  {Object} feature GeoJSON feature
   * @param  {Object} latlng  LatLng object
   * @return {Object} LeafletLayer
   */
  pointToLayerFn: function (rlayer, renderOptions, feature, latlng) {
    var layer = null;
    var iconContent = '';
    var icon = null;

    if (rlayer.type === 'waypoint') {
      var tags = rlayer.$tags;

      icon = MarkerUtil.getIcon({
        icon: rlayer.data.properties.marker.icon
      }, tags);

      layer = L.marker(latlng, {
        icon: icon,
        clickable: true,
        draggable: false
      });
    } else if (rlayer.type === 'routeLabel') {
      icon = MarkerUtil.getLabelIcon({
        text: rlayer.data.properties.label
      });

      layer = L.marker(latlng, {
        icon: icon,
        clickable: false,
        draggable: false
      });
    }

    return layer;
  },

  /**
   * This is a callback function executed when Leaflet is generating the layer 
   * and used to retrieve the LeafletLayer constructor options. 
   * 
   * @param  {Object} rlayer  Raw layer data
   * @param  {[type]} feature [description]
   * @return {[type]}         [description]
   */
  styleFn: function (rlayer, feature) {
    return _.extend({}, feature.properties.style, {
      dashArray: feature.properties.dashArray
    });
  }
});

module.exports = RouteTransform;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/layer/transform/geojson/mission/route/Route.js